import { Navigate } from "react-router-dom";
import { decodeJwt } from "../utils/decodeJwt";

export default function RequireSuperAdmin({ children }) {
  // Diagnostic: confirm component is actually executing
  //console.log("RequireSuperAdmin component executing");
  //console.log("Current URL:", window.location.pathname);

  const idToken = localStorage.getItem("idToken");
  //console.log("idToken inside guard:", idToken);

  // If no token → user is not logged in
  if (!idToken) {
    //console.log("No idToken found → redirecting to /auth/login");
    return <Navigate to="/auth/login" replace />;
  }

  // Decode the token
  const decoded = decodeJwt(idToken);
  //console.log("Decoded ID token:", decoded);

  // Extract groups (Cognito sometimes uses either key)
  const groups =
    decoded["cognito:groups"] ||
    decoded["groups"] ||
    [];

  //console.log("Groups inside token:", groups);

  // Check for super admin group
  const isSuperAdmin = groups.includes("cloudgenomics-admin");
  //console.log("Is SuperAdmin:", isSuperAdmin);

  if (!isSuperAdmin) {
    //console.log("User is NOT super admin → Access denied");
    return <div>Access denied — SuperAdmin only.</div>;
  }

  //console.log("User IS super admin → Access granted");
  return children;
}
